import { ValidationError } from './validation-error';
export class MemberKidValidation {
  relationship: ValidationError;
  constructor(relationship: ValidationError) {
    this.relationship = relationship;
  }
}
